<template>
    <div>
        <div class="lke-top">
            <p>1.以下信息和照片将作为您结业证书的使用信息，请您认真核对！</p>
            <p>2.照片应为2寸蓝色背景的彩色证件照。</p>
            <p class="lke-top-last">3.如需信息修改，请在修改信息完毕后刷新本页，以获得更改后的个人信息。</p>
        </div>
        <div class="lke-fot">
            <div class="lke-fot-l">
                <p><span>考生姓名：</span>社工学院</p>
                <p><span>考生账号：</span>123456789</p>
                <p><span>考生性别：</span></p>
                <p><span>出生日期：</span></p>
                <p><span>所属班级：</span>入学测试专科</p>
                <div class="lke-fot-l-button">
                    修改信息
                </div>
            </div>
            <div class="lke-fot-r">
                <div class="lke-fot-r-img">
                    <el-image
                            style="width: 132px; height: 185px;"
                            :src="url"
                            fit="fill"></el-image>
                </div>
                <div class="lke-fot-r-button">修改照片</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            url: '@/pages/index/assets/bird.jpeg',
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>

</style>

<style scoped>
.lke-top{
    padding: 10px 20px;
    border: 1px solid #C5CDE0;
    background: #F8F8F8;
}
.lke-top > p{
    line-height: 27px;
    color: #333333;
    font-size: 15px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
}
.lke-top-last{
    color: #ff0000 !important;
}
.lke-fot{
    display: flex;
    justify-content: center;
    padding: 40px;
}
.lke-fot-l{
    padding-right: 120px;
}
.lke-fot-l > p{
    line-height: 40px;
    color: #000000;
    font-size: 15px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
}
.lke-fot-r-img{
    padding: 3px;
    border: 1px solid #ccc;
}
.lke-fot-r-button{
    margin: 15px auto;
    width: 80px;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    font-size: 14px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
    background: #005CA9;
}
.lke-fot-r-button:hover{
    background: #2890F4;
}
.lke-fot-l-button{
    width: 160px;
    height: 50px;
    margin: 25px 0 0 0;
    background: url('http://lnsgsjnrz.eswonline.com/learning/resbase/sites/thtylnsg/student/default/public/exam/images/revise_info_btn.png') 0 0 no-repeat;
    line-height: 50px;
    color: #ffffff;
    letter-spacing: 20px;
    font-size: 18px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
    padding: 0 0 0 80px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/khjy/index.vue